import { provideHttpClient, withInterceptors } from '@angular/common/http'
import {
	APP_INITIALIZER,
	ApplicationConfig,
	EnvironmentInjector,
	ErrorHandler,
	inject,
	provideAppInitializer,
	provideZonelessChangeDetection,
} from '@angular/core'
import { provideRouter, Router, withViewTransitions } from '@angular/router'
import { LanguageService } from '@modules/lang-module/services/language.service'
import { provideTranslateService, TranslateService } from '@ngx-translate/core'
import { apiInterceptor } from '@shared/interceptors/api.interceptor'
import { errorsInterceptor } from '@shared/interceptors/errors.interceptor'
import { provideEventPlugins } from '@taiga-ui/event-plugins'
import { TUI_LANGUAGE, TuiLanguage } from '@taiga-ui/i18n'
import { BehaviorSubject, firstValueFrom } from 'rxjs'
import { routes } from './app.routes'
import { EnvironmentsService } from '@environments/core/services/environments.service'
import { EnvironmentsConfigsInterface } from '@environments/core/interfaces/environments-configs.interface'
import * as Sentry from '@sentry/angular'
import { provideAnimations } from '@angular/platform-browser/animations'

export let appInjector: EnvironmentInjector | null = null

export const appConfig: ApplicationConfig = {
	providers: [
		{
			provide: ErrorHandler,
			useValue: Sentry.createErrorHandler(),
		},
		{
			provide: Sentry.TraceService,
			deps: [Router],
		},
		provideAppInitializer((): void => {
			inject(Sentry.TraceService)
		}),
		provideHttpClient(withInterceptors([apiInterceptor, errorsInterceptor])),
		provideZonelessChangeDetection(),
		provideRouter(routes, withViewTransitions()),
		provideAppInitializer((): Promise<EnvironmentsConfigsInterface> => {
			const environmentsService: EnvironmentsService = inject<EnvironmentsService>(EnvironmentsService)

			return firstValueFrom(environmentsService.getEnvironmentsConfigs())
		}),
		provideEventPlugins(),
		{
			provide: TUI_LANGUAGE,
			useFactory: (langService: LanguageService): BehaviorSubject<TuiLanguage> => langService.languageTaiga$,
			deps: [LanguageService],
		},
		{
			provide: APP_INITIALIZER,
			multi: true,
			useFactory:
				(env: EnvironmentInjector): (() => void) =>
				(): void => {
					appInjector = env
				},
			deps: [EnvironmentInjector],
		},
		provideTranslateService(),
		provideAnimations(),
		TranslateService,
	],
}
